import { AbstractDataProviderV2, IDataProviderV2 } from 'components/system';
import { RsCustomerGroupType, RsCustomerGroupTypeInfo, CustomerGroupTypeAdd, CustomerGroupTypeUpdate } from 'common/customers/services/types';

export type ICustomerGroupTypesDataProvider = IDataProviderV2<
    RsCustomerGroupType,
    RsCustomerGroupTypeInfo,
    CustomerGroupTypeAdd,
    CustomerGroupTypeUpdate
>;

export class CustomerGroupTypesDataProvider
    extends AbstractDataProviderV2<RsCustomerGroupType, RsCustomerGroupTypeInfo, CustomerGroupTypeAdd, CustomerGroupTypeUpdate>
    implements ICustomerGroupTypesDataProvider
{
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/dict/group-types');
    }
}
